import React, { FC } from 'react';
import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { InstallExtension } from '../../../../SideBar/SettingsModal/InstallExtension';
import { SETTING_ICONS } from '../../../constants';
import './ChromeExtensionSection.scss';

const ChromeExtensionSection: FC = () => {
  const Icon = SETTING_ICONS.chrome;
  const { t } = useTranslation();

  return (
    <div className="chrome-extension-section chrome-extension-section--new-tabs">
      <div className="chrome-extension-section__block">
        <Stack gap={1} direction="row" alignItems="center">
          <Icon className="chrome-extension-section__section-icon" />
          <Typography variant="body1" className="chrome-extension-section__section-title">
            {t('settings.productHub.chromeExtension')}
          </Typography>
        </Stack>
        <InstallExtension />
      </div>
    </div>
  );
};

export default ChromeExtensionSection;
